import React, { FunctionComponent } from 'react';
import '@justgiving/loading/src/Loading.scss';

import { AuctionLot } from '../../../../types/__generated__';
import { Button } from '../../Button/Button';
import styles from './AuctionLotPanel.scss';

interface AuctionLotProps {
  lot: AuctionLot;
  onClick: (lot: AuctionLot) => void;
  winning: boolean;
  userHighestBid?: number;
}

export const AuctionLotPanel: FunctionComponent<AuctionLotProps> = ({
  lot,
  onClick,
  winning,
  userHighestBid,
}) => {
  const { title, description, image, highestBid, isEnded } = lot;

  const biddingAlert = winning
    ? 'You are the highest bidder!'
    : userHighestBid
    ? `You have been out bid - your last bid was £${userHighestBid}`
    : undefined;

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>
        <h3>{title}</h3>
        {(isEnded || biddingAlert) && (
          <p className={styles.bidding_alert}>
            {isEnded ? 'Bidding has ended. ' : ''}
            {biddingAlert}
          </p>
        )}
      </div>
      <p className={styles.description}>{description}</p>
      <img className={styles.image} src={image.url} alt={title} />
      <div className={styles.bidding}>
        <h4 className={styles.bid}>
          {isEnded ? 'Winning bid: ' : 'Current highest bid: '}£
          {highestBid.value}
        </h4>
        <Button
          type="button"
          onClick={() => onClick(lot)}
          disabled={isEnded || winning}
          className={styles.button}
        >
          {winning
            ? 'You already have the highest bid'
            : userHighestBid
            ? 'Increase your bid now'
            : 'Bid Now'}
        </Button>
      </div>
    </div>
  );
};
